export class GeneralConfig {
    constructor(
        readonly general: GeneralSettingsConfig,
        readonly log: LogConfig,
        readonly email: EmailConfig,
        readonly sms: SmsConfig
    ) { }
}

export class GeneralSettingsConfig {
    constructor(
        readonly workingDirectory: string,
        readonly batchSizeDeletingJobs: number,
        readonly refreshLastHour: number
    ) { }
}

export class LogConfig {
    // eslint-disable-next-line max-params
    constructor(
        readonly filename: string,
        readonly level: LogLevel,
        readonly maxBackupFiles: number,
        readonly maxSize: number,
        readonly maxSizeUnits: SizeUnits,
        readonly mode: Mode,
        readonly server: string,
        readonly port: number,
        readonly logDeleted: boolean,
        readonly customMessageFormat: string,
        readonly customDateFormat: string
    ) { }
}

export enum LogLevel {
    All = 'all',
    Info = 'info',
    Error = 'error',
    Warning = 'warning',
    Debug = 'debug',
    Trace = 'trace'
}

export enum SizeUnits {
    KB = 'kb',
    MB = 'mb',
    GB = 'gb'
}

export enum Mode {
    File = 'file',
    TCP = 'tcp',
    UDP = 'udp',
    Console = 'console'
}

export enum JobsViewMode {
    All = 'all',
    Own = 'own'
}
export class EmailConfig {
    // eslint-disable-next-line max-params
    constructor(
        readonly fromDefaultAddress: string,
        readonly smtpServer: string,
        readonly defaultSmtpUser: string,
        readonly smtpPassword?: string,
        public authenticationType?: AuthenticationType,
        public tlsVersion?: TlsVersion
    ) { }
}

export class SmsConfig {
    constructor(
        readonly smsPhoneNumber: string,
        readonly smsAccount: string,
        readonly smsToken: string
    ) { }
}

export enum GeneralConfigSection {
    General = 'general',
    Log = 'log',
    Email = 'email',
    Sms = 'sms'

}

export enum AuthenticationType {
    Tls = 'tls',
    Ssl = 'ssl',
    WithoutAuthentication = 'without-authentication'
}

export enum TlsVersion {
    Default = 'default',
    First = '1.1',
    Second = '1.2',
    Third = '1.3'
}